import type { QueryKey, UseQueryOptions } from '@tanstack/react-query';
import {
  getSearchSuggestions,
  type SearchSuggestionsParams,
  getSearchContentSuggestion,
  type SearchContentSuggestionParams,
} from './search.api';
import type { OptionalQueryOptions, QueryApiOptions } from '../../types/types';
import { SearchContent, SearchSuggestions } from '@as-react/common-types';

export const searchQueryKeys = {
  all: () => ['search'] as QueryKey,
  SearchSuggestions: (params: SearchSuggestionsParams) =>
    [...searchQueryKeys.all(), 'SearchSuggestions', params] as QueryKey,
  SearchContentSuggestion: (params: SearchContentSuggestionParams) =>
    [...searchQueryKeys.all(), 'SearchContentSuggestion', params] as QueryKey,
};

export const searchQueries = (apiOptions: QueryApiOptions) => ({
  getSearchSuggestions: <TReturnData>(
    params: SearchSuggestionsParams,
    options: OptionalQueryOptions<SearchSuggestions, TReturnData> = {}
  ) =>
    ({
      ...options,
      queryKey: searchQueryKeys.SearchSuggestions(params),
      queryFn: () => getSearchSuggestions(apiOptions, params),
    } as UseQueryOptions<SearchSuggestions, Error, TReturnData>),
  getSearchContentSuggestion: <TReturnData>(
    params: SearchContentSuggestionParams,
    options: OptionalQueryOptions<SearchContent, TReturnData> = {}
  ) =>
    ({
      ...options,
      queryKey: searchQueryKeys.SearchContentSuggestion(params),
      queryFn: () => getSearchContentSuggestion(apiOptions, params),
    } as UseQueryOptions<SearchContent, Error, TReturnData>),
});
